import React from 'react'

const CloseIcon = (props) => {
	return(
		<svg xmlns="http://www.w3.org/2000/svg" width="10" height="9.333" viewBox="0 0 10 9.333"><path d="M5.346 6.672l-.013.013-.333-.334-.333.334-.013-.013-2.654 2.661-2-2.006 2.653-2.661-2.653-2.661 2-2.005 2.653 2.661.014-.014.333.334.333-.334.014.014 2.653-2.661 2 2.005-2.653 2.661 2.653 2.661-2 2.006z" fill={props.fill}/></svg>
	)
}

export default CloseIcon